import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import Header from './Header';
import { getShowSidebar } from 'store/sidebar/selectors';
import { showSidebar } from 'store/sidebar/actions';

const mapStateToProps = createSelector(
  getShowSidebar,
  showSidebar => ({ showSidebar })
);

const actions = dispatch => ({
  onShowSidebarClicked: () => {
    dispatch(showSidebar());
  }
});

export default connect(mapStateToProps, actions)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js